import { TypeButton } from "../../fonts/Types";
import "./Button.css";

const variantClass = (variant) => {
	switch (variant) {
		case 1:
		case "primary":
			return "btnPrimary";
		case 2:
		case "secondary":
			return "btnSecondary";
		case 3:
		case "ghost":
			return "btnGhost";
		default:
			return "btnPrimary";
	}
};

// Magnetic pull: the button leans a few pixels toward the pointer and a
// light sweep tracks it. Coarse pointers (touch) skip it.
function onPointerMove(e) {
	if (e.pointerType !== "mouse") return;
	const el = e.currentTarget;
	const r = el.getBoundingClientRect();
	const x = e.clientX - r.left;
	const y = e.clientY - r.top;
	el.style.setProperty("--mx", `${((x - r.width / 2) / r.width) * 10}px`);
	el.style.setProperty("--my", `${((y - r.height / 2) / r.height) * 8}px`);
	el.style.setProperty("--hx", `${x}px`);
	el.style.setProperty("--hy", `${y}px`);
}

function onPointerLeave(e) {
	e.currentTarget.style.setProperty("--mx", "0px");
	e.currentTarget.style.setProperty("--my", "0px");
}

export function StandarButton({ variant, icon, label, href, onClick, type = "button", target, rel }) {
	const className = variantClass(variant);
	const magnetic = { onPointerMove, onPointerLeave };
	const inner = (
		<>
			<TypeButton>{label}</TypeButton>
			{icon}
		</>
	);

	if (href) {
		return (
			<a className={className} href={href} target={target} rel={rel} onClick={onClick} {...magnetic}>
				{inner}
			</a>
		);
	}

	return (
		<button className={className} type={type} onClick={onClick} {...magnetic}>
			{inner}
		</button>
	);
}
